/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const TemplateTypeEnum = {
    EMPLOYER: 'EMPLOYER',
    PROVIDER: 'PROVIDER'
} as const;
export type TemplateTypeEnum = typeof TemplateTypeEnum[keyof typeof TemplateTypeEnum];

